<template>
    <div>
        <div class="form-group col-12">
            <label for="teacher">Ad position</label>

            <v-select
                v-model="selectedAdPosition"
                label="name"
                :options="adPositions"
                placeholder="Select ad position"
                :class="{
                    'is-invalid': hasError('adPositionId')
                }"
            />

            <div class="invalid-feedback">
                {{ getError('adPositionId') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label for="exposure">Exposure</label>

            <div class="prefix-wrapper">
                <span class="prefix"> % </span>

                <input
                    id="exposure"
                    v-model.number="ad.exposure"
                    type="number"
                    class="form-control"
                    :class="{
                        'is-invalid': hasError('exposure')
                    }"
                    placeholder="Exposure"
                />
            </div>
            <div
                class="invalid-feedback"
                :style="{ display: hasError('exposure') ? 'block' : 'none' }"
            >
                {{ getError('exposure') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="ad.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
                placeholder="Name"
            />
            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label for="link">Link</label>
            <input
                id="link"
                v-model="ad.link"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('link')
                }"
                dir="auto"
                placeholder="Link"
            />
            <div class="invalid-feedback">
                {{ getError('link') }}
            </div>
        </div>

        <div v-if="isHomepageBalloon" class="col-12 form-group d-flex">
            <div class="w-50 mr-3">
                <label for="image">Bubble Image</label>

                <media-chooser
                    v-model="ad.bubbleBannerImageId"
                    :error-border="!!hasError('bubbleBannerImageId')"
                    recommended-size="200x200"
                    type="image"
                    id-only
                />
            </div>

            <div class="w-50 ml-3">
                <label for="image">Full Image</label>

                <media-chooser
                    v-model="ad.imageId"
                    :error-border="!!hasError('imageId')"
                    :recommended-size="recommendedSize"
                    type="image"
                    id-only
                />
            </div>
        </div>

        <div v-else class="col-12 form-group">
            <label for="image">Image</label>

            <media-chooser
                v-model="ad.imageId"
                :error-border="!!hasError('imageId')"
                :recommended-size="recommendedSize"
                type="image"
                id-only
            />
        </div>

        <div class="form-group col-12">
            <label for="title">Title</label>
            <input
                id="title"
                v-model="ad.title"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': !!getError('title')
                }"
                dir="auto"
                placeholder="Title"
            />
            <div class="invalid-feedback">
                {{ getError('title') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label for="description">Description</label>
            <input
                id="description"
                v-model="ad.description"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': !!getError('description')
                }"
                dir="auto"
                placeholder="Description"
            />
            <div class="invalid-feedback">
                {{ getError('description') }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            ad: {},
            adPositions: [],
            selectedAdPosition: null,
            isHomepageBalloon: false
        };
    },

    computed: {
        recommendedSize() {
            return this.selectedAdPosition
                ? `${this.selectedAdPosition.width}x${this.selectedAdPosition.height}`
                : null;
        }
    },

    watch: {
        ad() {
            this.$emit('input', this.ad);
        },

        selectedAdPosition() {
            this.ad.adPositionId = this.selectedAdPosition
                ? this.selectedAdPosition.id
                : null;

            this.ad.adPosition = this.selectedAdPosition;

            this.isHomepageBalloon =
                this.selectedAdPosition?.slot === 'homepage-balloon';
        }
    },

    async mounted() {
        const {
            query: { adPositionId }
        } = this.$route;

        this.ad = { ...this.value };

        const { rows: adPositions } = await this.getAdPositions();

        this.adPositions = adPositions;

        if (this.ad.adPositionId) {
            this.selectedAdPosition = this.ad.adPosition;
        }

        if (adPositionId) {
            const adPosition = await this.getAdPosition(adPositionId);

            if (adPosition) {
                this.selectedAdPosition = adPosition;
            }
        }
    },

    methods: {
        ...mapActions({
            getAdPosition: 'adPositions/show',
            getAdPositions: 'adPositions/index'
        }),

        hasError(key) {
            return (
                this.validation.ad[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.ad,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
